import UtilsSchema from "@repoflow/schema/utils";

import FieldsSchema, {
  host,
  orgId,
  siteId,
  status,
  token,
  verifiedAt,
  createdAt,
  updatedAt,
} from "./fields";

export default [
  ...UtilsSchema,
  ...FieldsSchema,
  {
    id: "/Public/SiteDomain",
    type: "object",
    properties: {
      host,
      orgId,
      siteId,
      status,
      // Returned to the owning organization so the attach screen can show the
      // record to publish. The resolver is what keeps it there — see the note
      // on `token` in @common/schema/site-domain/fields.
      token,
      verifiedAt,
      createdAt,
      updatedAt,
    },
  },
  {
    // `host` and nothing else. The site is the resolved parent and the
    // organization is the caller, so neither is an input: a create that took
    // `orgId` would be a create that could name somebody else's.
    id: "/Public/SiteDomain/Create",
    type: "object",
    properties: {
      host,
    },
    required: ["host"],
  },
];
